import type { AppMeta, OptionMeta } from '@clientline/contracts';

/**
 * «Тип наступного кроку» зберігає ключ типу задачі, а людині потрібна його назва (рішення власника
 * 02.11, #1228). Поле лишається текстом, реєстр типів у `/meta` живе на прив'язці задач, тож типи стають
 * варіантами поля: їх уже читає `display`. Ключ без типу видно як є. Бюджет першого екрана вичерпано,
 * тому без копій: об'єкт щойно прийшов із мережі.
 */
export function withNextStepLabels(meta: AppMeta): AppMeta {
  const options = meta.entities
    .map((entity) => (entity.behaviors?.activities_task as { types?: OptionMeta[] })?.types)
    .find(Array.isArray);
  for (const entity of meta.entities) {
    const field = options && entity.fields.find((f) => f.key === 'next_activity_type');
    if (field) field.options = options;
  }
  return meta;
}
